import React, { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import type { ExtraConfig } from '@gov-nx/core/app/extra-config/context.types';
import { getPagePartSlug } from '@gov-nx/module/page/definitions/PageMap';
import { pageRouteResolver } from '@gov-nx/web/Router/routeResolver';
import AuthorizedRoute from '../../routes/AuthorizedRoute';

const SettingsPage = lazy(() =>
	import('./Setting').then(({ SettingPage }) => ({ default: SettingPage }))
);

export const getSettingsRoutes = (
	extraConfig: ExtraConfig['settingsRoutes']
): RouteObject[] => [
	{
		path: getPagePartSlug('nastaveni'),
		element: (
			<AuthorizedRoute>
				<SettingsPage {...extraConfig.settingsPageConfig} />
			</AuthorizedRoute>
		),
	},
	{
		path: pageRouteResolver('nastaveni.kontaktni-udaje'),
		element: <Navigate to={pageRouteResolver('nastaveni')} />,
	},
];
